import { DOCUMENT } from '@angular/common';
import { effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ENVIRONMENT, isDemo, isDevelop } from '@environment';
import { isLocalhost } from '@usheru-hff/sdk/utils';

import { MovieSiteEditorService } from './form-editor.service';

/**
 * Opens the editor modal if the query param `editMovie=true` is present and on localhost or demo/develop.
 */
export function useMovieSiteEditorEffect(): void {
  const editorService = inject(MovieSiteEditorService);
  const doc = inject(DOCUMENT);
  const env = inject(ENVIRONMENT);

  effect(
    () => {
      const toURL = new URL(doc.URL);
      const showMovieSiteEditor = toURL.searchParams.get('editMovie');

      if (showMovieSiteEditor && (isDemo(env) || isDevelop(env) || isLocalhost(doc))) {
        editorService.isEnabled.set(true);
        editorService.open();
      } else {
        editorService.isEnabled.set(false);
      }
    },
    {
      allowSignalWrites: true
    }
  );
}
